import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'allas-contact-footer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="mt-12 p-8">
      <h3 class="text-xl font-normal fs-condensed text-gray-700 mb-4">
        ¿Prefieres llamar? Contacta al soporte de pedidos por teléfono al +504
        2283-4540
      </h3>
      <div class="text-gray-700 fs-condensed">
        <div class="grid grid-cols-2 gap-x-8 gap-y-2">
          <!-- Días -->
          <div class="space-y-2">
            <p class="text-black font-bold">Lunes - Viernes</p>
            <p class="text-black font-bold">Sábado</p>
            <p class="text-black font-bold">Domingo</p>
          </div>
          <!-- Horarios -->
          <div class="space-y-2">
            <p class="text-black">8:00 AM - 5:00 PM</p>
            <p class="text-black">8:00 AM - 3:00 PM</p>
            <p class="text-black">CERRADO</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="mt-12 p-8">
      <p class="text-lg text-gray-700 mb-4 fs-condensed">
        Allas Repuestos respeta tu privacidad y preocupaciones de seguridad.
      </p>
      <div
        class="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 text-sm"
      >
        <a
          href="/privacidad"
          class="text-gray-600 hover:text-orange-500 transition-colors underline"
        >
          Estándares de Seguridad
        </a>
        <span class="hidden sm:inline">|</span>
        <a
          href="/privacidad"
          class="text-gray-600 hover:text-orange-500 transition-colors underline"
        >
          Política de Privacidad
        </a>
        <span class="hidden sm:inline">|</span>
        <a
          href="/preguntas-frecuentes"
          class="text-gray-600 hover:text-orange-500 transition-colors underline"
        >
          Lee nuestras Preguntas Frecuentes
        </a>
        <span class="hidden sm:inline">|</span>
        <a
          href="/privacidad"
          class="text-gray-600 hover:text-orange-500 transition-colors underline"
        >
          Nuestros Términos y Condiciones
        </a>
      </div>
    </div>
  `,
})
export class AllasContactFooterComponent {}
